// Colorbook
// Brand
export const colorWhite = '#fff';
export const colorCharcoal012 = '#1f1f1f';
export const colorCharcoal032 = '#525252';
export const colorCharcoal054 = '#8a8a8a';

export const colorLinen095 = '#f2efe9';
export const colorLinen098 = '#faf8f5';

export const colorPeacock018 = '#1c2e2e';
export const colorPeacock028 = '#2c4747';
export const colorPeacock048 = '#4c7a7a';
export const colorPeacock086 = '#bddbdb';
export const colorPeacock096 = '#f0fafa';

// State
export const colorStateDisabled = '#999';
export const colorStateDisabledLight = '#dbdbdb';

export const colorStateError = '#c44848';

// Typography
export const fontFamilySans = `'Open Sans', sans-serif`;
export const fontFamilySerif = `'Old Standard TT', serif`;
export const weightLight = 300;
export const weightRegular = 400;
export const weightSemiBold = 600;
export const weightBold = 700;
export const fontStyleItalic = 'italic';

// Spacing
export const spaceNone = '0 0 0 0';

// Space Center
export const spaceCenter = `0 auto`;

// Space Inset
export const spaceInsetDefault = `1.6rem 1.6rem 1.6rem 1.6rem`;
export const spaceInsetEighth = `0.2rem 0.2rem 0.2rem 0.2rem`;
export const spaceInsetQuarter = `0.4rem 0.4rem 0.4rem 0.4rem`;
export const spaceInsetHalf = `0.8rem 0.8rem 0.8rem 0.8rem`;
export const spaceInsetDouble = `3.2rem 3.2rem 3.2rem 3.2rem`;
export const spaceInsetQuad = `6.4rem 6.4rem 6.4rem 6.4rem`;

// Space Inset Squish
export const spaceInsetSquishDefault = `0.8rem 1.6rem`;
export const spaceInsetSquishHalf = `0.4rem 0.8rem`;
export const spaceInsetSquishDouble = `1.6rem 3.2rem`;

// Space Inset Stretch
export const spaceInsetStretchDefault = `2.4rem 1.6rem`;
export const spaceInsetStretchHalf = `1.2rem 0.8rem`;
export const spaceInsetStretchDouble = `3.2rem 1.6rem`;

// Space Stack
export const spaceStackDefault = `0 0 1.6rem 0`;
export const spaceStackEighth = `0 0 0.2rem 0`;
export const spaceStackQuarter = `0 0 0.4rem 0`;
export const spaceStackHalf = `0 0 0.8rem 0`;
export const spaceStackDouble = `0 0 3.2rem 0`;
export const spaceStackQuad = `0 0 6.4rem 0`;
export const spaceStackOct = `0 0 12.8rem 0`;

// Space Stack Center
export const spaceStackCenterDefault = `0 auto 1.6rem auto`;
export const spaceStackCenterEighth = `0 auto 0.2rem auto`;
export const spaceStackCenterQuarter = `0 auto 0.4rem auto`;
export const spaceStackCenterHalf = `0 auto 0.8rem auto`;
export const spaceStackCenterDouble = `0 auto 3.2rem auto`;
export const spaceStackCenterQuad = `0 auto 6.4rem auto`;
export const spaceStackCenterOct = `0 auto 12.8rem auto`;

// Space Stack Inline
export const spaceStackInlineDefault = `0 1.6rem 1.6rem 0`;
export const spaceStackInlineEighth = `0 0.2rem 0.2rem 0`;
export const spaceStackInlineQuarter = `0 0.4rem 0.4rem 0`;
export const spaceStackInlineHalf = `0 0.8rem 0.8rem 0`;
export const spaceStackInlineDouble = `0 3.2rem 3.2rem 0`;
export const spaceStackInlineQuad = `0 6.4rem 6.4rem 0`;

// Space Inline
export const spaceInlineDefault = `0 1.6rem 0 0`;
export const spaceInlineEighth = `0 0.2rem 0 0`;
export const spaceInlineQuarter = `0 0.4rem 0 0`;
export const spaceInlineHalf = `0 0.8rem 0 0`;
export const spaceInlineDouble = `0 3.2rem 0 0`;
export const spaceInlineQuad = `0 6.4rem 0 0`;

// Space Helpers
export const spaceDefault = `1.6rem`;
export const spaceEighth = `0.2rem`;
export const spaceQuarter = `0.4rem`;
export const spaceHalf = `0.8rem`;
export const spaceDouble = `3.2rem`;
export const spaceQuad = `6.4rem`;

// Space Value Helpers
export const spaceValueDefault = 1.6;
export const spaceValueEighth = 0.2;
export const spaceValueQuarter = 0.4;
export const spaceValueHalf = 0.8;
export const spaceValueDouble = 3.2;
export const spaceValueQuad = 6.4;

// Design Elements
export const borderRadius = '0.2rem';
export const elevation1 = '0 1.6rem 4rem rgba(44, 71, 71, 0.1), 0 1rem 3.2rem rgba(31, 31, 31, 0.08)';
export const elevation2 = '0 2rem 4rem rgba(44, 71, 71, 0.1), 0 1.2rem 3.2rem rgba(31, 31, 31, 0.08)';
export const transition = '300ms ease-in-out';
